import React, { useEffect, useState } from "react";
import "./Login.css";
import Buttons from "../../../components/ButtonsComp";
import { useNavigate } from "react-router-dom";
import PageURL from "../../../constants/PageURL";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import {
  clear_errors,
  FORGOT_PASSWORD_RESET,
  send_otp_reset,
} from "../../../constants/dataConstants";
import { forgotPassword, sendOtp } from "../../../actions/userActions";
import Loader from "../../../components/Loader";

const ForgotPassword = (props) => {
  const navigate = useNavigate();
  const [username, setusername] = useState("");
  const [countdown, setCountdown] = useState(0);
  const dispatch = useDispatch();
  const { isForgotPassword, forgotPasswordLoading, forgotPasswordError } =
    useSelector((state) => state.user);

  /* #####  Send OTP Handler for forgot password  ##### */

  const sendOtpHandler = () => {
    if (
      !username.match(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      )
    ) {
      toast.error("Enter a valid username");
      return;
    }

    /* #####  dispatch actions to send otp  ##### */

    dispatch(forgotPassword(username));
  };

  useEffect(() => {
    if (forgotPasswordError) {
      toast.error(forgotPasswordError);
      dispatch({ type: clear_errors });
    }
    if (isForgotPassword) {
      toast.success("Reset password link send to your mail successfully!");
      dispatch({ type: FORGOT_PASSWORD_RESET });
      setusername("");
      setCountdown(60); // start countdown
    }
  }, [navigate, dispatch, forgotPasswordError, isForgotPassword]);
  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);
  return (
    <div style={{ width: "100%" }} className="login-box">
      {forgotPasswordLoading && <Loader />}
      <h2 style={{ textAlign: "center" }}>Forgot Password</h2>
      <div className="inputs" style={{ width: "80%" }}>
        <input
          type="text"
          placeholder="Enter Your Username"
          style={{
            textAlign: "center",
            fontWeight: "bolder",

            color: "black",
          }}
          value={username}
          onChange={(e) => {
            setusername(e.target.value);
          }}
        />
      </div>
      <div style={{ flexDirection: "row" }} className="buttons">
        <Buttons
          type="contained"
          buttonType="primary"
          buttonText="Back"
          onClick={() => {
            navigate(PageURL.BASE);
          }}
        ></Buttons>
        <Buttons
          type="outlined"
          buttonType="secondary"
          buttonText={countdown > 0 ? `Wait (${countdown}s)` : "Send Link"}
          onClick={() => (countdown > 0 ? null : sendOtpHandler())}
          disabled={countdown > 0}
        />
      </div>
    </div>
  );
};

export default ForgotPassword;
